// import { MediaRecorder, register } from 'extendable-media-recorder';
// import { connect as connectEncoder } from 'extendable-media-recorder-wav-encoder';
import hark from "hark";

let generateMediaRecorderCalled = false;

const GlobalMedia = () => {
    let mediaRecorder;
    let speechEvents;
    let initialized = false;
    let config;
    if (typeof window != 'undefined') {
        window.afterGlobalMedia = function (cb, config, override) {
            if (!window.objMd && !generateMediaRecorderCalled) {
                generateMediaRecorderCalled = true;
                generateMediaRecorder(cb, config);
            } else {
                if(override) {
                    overrideMediaRecord(cb, config);
                }
                delayCallback();
                function delayCallback() {
                    setTimeout(() => {
                        if (cb && typeof cb == "function" && window.objMd) {
                            // console.log("gm_ cb called");
                            cb();
                        } else {
                            if (!window.objMd) {
                                console.log("gm_ delaycb called")
                                delayCallback();
                            } else {
                                console.log("gm_ cb is not function")
                            };
                        }
                    }, 2000);
                }
            }
        }
        console.log("gm_ agm gobalMedia", window.afterGlobalMedia);
        window.afterGlobalMedia();

        async function generateMediaRecorder(cb, config = {}) {
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                try {
                    const stream = await navigator.mediaDevices.getUserMedia({
                        audio: ( config.deviceId && {deviceId :config.deviceId}) || true,
                        video: false
                    });
                    console.log('stream ', stream);
                    // if(state!=="inactive") {
                    // await register(await connectEncoder());
                    // }
                    const options = {
                        mimeType: 'audio/wav'
                    }
                    mediaRecorder = new MediaRecorder(stream.clone());
                    speechEvents = hark(stream, {interval: 100, threshold: -50});
                    initialized = true;
                    // speechEvents.setInterval(500);
                    // speechEvents.setThreshold(-50);
                } catch (ex) {
                    window.inputDeviceError = true;
                    window.alert("Your microphone is not working , Please use other microphone to start.");
                }
                
            } else {
                console.log('getUserMedia not supported on your browser!');
            }

            window.objMd = { mediaRecorder, speechEvents };

            if (cb && typeof cb == "function") {
                console.log("gm_ inside generateMdiaR cb called");
                cb();
            } else {
                console.log("gm_ else inside generateMdiaR cb is not function");
            }
        }

        async function overrideMediaRecord(cb, config = {}) {
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia && config && initialized) {
                try {
                    console.log("Device: "+ config);
                    const stream = await navigator.mediaDevices.getUserMedia({
                        audio: ( config.deviceId && {deviceId :config.deviceId}) || true,
                        video: false
                    });
                    const options = {
                        mimeType: 'audio/wav'
                    }
                    mediaRecorder = new MediaRecorder(stream.clone());
                    speechEvents = hark(stream, {interval: 100, threshold: -50});
                } catch (ex) {
                    window.inputDeviceError = true;
                    window.alert("Your microphone is not working , Please use other microphone to start.");
                }
            } else {
                console.log('getUserMedia not supported on your browser!');
            }
            window.objMd = { mediaRecorder, speechEvents };
            if (cb && typeof cb == "function") {
                cb();
            }
        }
    }
}

export default GlobalMedia;
